<template>
  <div class="wrapper">
    <public-title phone="手机号" name="昵称" role="角色" @gotobtn="btn" @gotoinquire="eventinquire" :isbtn="true" :roles="rolearr" btnname="新增"
      icon="el-icon-plus">
    </public-title>
    <div class="content">
      <el-table :data="tabledata" style="width: 100%" >
        <el-table-column prop="username" label="账号" align="center">
        </el-table-column>
        <el-table-column prop="nickname" label="用户昵称" align="center">
        </el-table-column>
        <el-table-column prop="phone"  label="手机号" align="center">
        </el-table-column>
        <el-table-column prop="roleName" label="角色" align="center">
        </el-table-column>
        <el-table-column label="操作" width="320" align="center">
          <template slot-scope="scope">
            <el-button size="mini" type="primary" @click="setrole(scope.$index, scope.row)">设置角色</el-button>
            <!-- <el-popconfirm icon="el-icon-info" v-model="DelVisible1" confirmButtonText='确定' cancelButtonText='取消'
              @onConfirm="edit(scope.$index, scope.row)" iconColor="red" style="margin-left: 10px;"
              title="您确定要重置密码吗？"> -->
              <el-button  slot="reference" size="mini" type="primary" @click="edit(scope.$index, scope.row)">重置密码</el-button>
            <!-- </el-popconfirm> -->
            <!-- <el-popconfirm icon="el-icon-info" v-model="DelVisible" confirmButtonText='确定' cancelButtonText='取消'
              @onConfirm="handleDelete(scope.$index, scope.row)" iconColor="red" style="margin-left: 10px;"
              title="您确定要删除这一条记录吗？"> -->
              <el-button slot="reference" size="mini" type="danger" @click="handleDelete(scope.$index, scope.row)">删除</el-button>
            <!-- </el-popconfirm> -->
          </template>
        </el-table-column>
      </el-table>
      <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="currentPage"
        :page-sizes="[15, 30, 40, 50]" :page-size="100" layout="total, sizes, prev, pager, next, jumper"
        :total="totals">
      </el-pagination>
    </div>
    <el-dialog :title="issubbtn?'新增用户':'设置角色'" :before-close="handleClose"  :visible.sync="dialogVisible" width="35%">
      <el-form ref="form" :model="subform" :rules="rules" label-width="80px">
        <el-form-item v-if="issubbtn" label="账号" prop="username" >
          <el-input v-model="subform.username" placeholder="请输入账号"></el-input>
        </el-form-item>
        <el-form-item v-if="issubbtn" label="用户昵称" prop="nickname" >
          <el-input v-model="subform.nickname" placeholder="请输入用户昵称"></el-input>
        </el-form-item>
        <el-form-item v-if="issubbtn" label="密码" prop="password" >
          <el-input v-model="subform.password" placeholder="请输入密码"></el-input>
        </el-form-item>
        <el-form-item v-if="issubbtn" label="手机号" prop="phone" >
          <el-input v-model="subform.phone" placeholder="请输入手机号"></el-input>
        </el-form-item>
        <el-form-item label="角色" prop="roleId">
          <!-- @change="source" -->
          <el-select v-model="subform.roleId" clearable filterable placeholder="请选择角色"  style="width:100%;">
              <el-option
                v-for="item in rolearr"
                :key="item.id"
                :label="item.roleName"
                :value="item.id"
                :disabled="item.roleCode == 'SUPER_ADMIN'"
                >
              </el-option>
          </el-select>
        </el-form-item>
        <el-form-item style="text-align: right;">
          <el-button type="primary" @click="onSubmit('form')">保存</el-button>
          <el-button @click="quxiao()">取消</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>

  </div>
</template>
<script>
  import publicTitle from '../../../components/publicTitle'
  export default {
    components: { publicTitle },
    props: {},
    data() {
      var phone=/^[1][3,4,5,7,8,9][0-9]{9}$/;
      var password= /^[A-Za-z0-9]{6,12}$/;

      var phone1 = (rule, value, callback) => {
        if (!phone.test(value)) {
          callback(new Error("请填写正确手机号"));
        }else{
          callback();
        }
      };
      var password1 = (rule, value, callback) => {
        if (!password.test(value)) {
          callback(new Error("密码请填写6-12位，数字或字母密码"));
        }else{
          callback();
        }
      };
      var username1 = (rule, value, callback) => {
        if (!password.test(value)) {
          callback(new Error("账号请填写6-12位，数字或字母账号"));
        }else{
          callback();
        }
      };
      return {
        tabledata: [],
        currentPage: 1,
        pageSize: 15,
        pageIndex: 1,
        totals: 0,
        form: {},
        subform:{
          username:'', //账号
          nickname:'', //用户昵称
          password:'', //	密码
          roleId:'', //角色id
          phone:'', //手机号
        },
        DelVisible: false,
        DelVisible1: false,
        dialogVisible: false,
        rules: {
          username: [
           {required: true, validator: username1, trigger: 'blur' },
          ],
          nickname: [
            { required: true, message: '请输入用户昵称', trigger: 'blur' },
          ],
          password: [
            {required: true, validator: password1, trigger: 'blur' },
          ],
          phone: [
            {required: true, validator: phone1, trigger: 'blur' },
          ],
          roleId: [
            { required: true, message: '请选择角色', trigger: 'change' },
          ],
          /* sex: [
            { required: true, message: '请选择性别', trigger: 'change' },
          ], */
        },
        issubbtn:false, // edit fals - add true
        rolearr:[],
        sex:[{
          value: '1',
          label: '男'
        }, {
          value: '2',
          label: '女'
        }],
        listid:''
      };
    },
    computed: {
    },
    mounted() {
      this.updata()
      this.rolequery()
    },
    methods: {
      setrole(idnex,item){
        this.issubbtn = false
        this.dialogVisible = true
        this.listid = item.id
        this.subform.roleId = item.roleId
        console.log(item)
      },
      rolequery(callback){
        this.$http({
          url: this.$api.rolelist,
          method: "GET",
        }).then(res => {
          if (res.data.code == 200) {
            this.rolearr = res.data.data
          }
        });
      },
      updata(pageIndex = 1, pageSize = 15, Vphone = '', Vrole = '', Vname = '') {
        this.$http({
          url: this.$api.userlist + `?pageIndex=${pageIndex}&pageSize=${pageSize}&phone=${Vphone}&roleId=${Vrole}&nickname=${Vname}`,
          method: "GET",
        }).then(res => {
          if (res.data.code == 200) {
            console.log(res.data)
            this.tabledata = res.data.data.records
            this.pageSize = res.data.data.size
            this.currentPage = res.data.data.current
            this.totals = res.data.data.total
          }else{
            this.$toast("error", res.data.msg);
          }
        });
      },
      eventinquire(form) {
        this.form = form
        this.updata(1, this.pageSize, this.form.Vphone, this.form.Vrole, this.form.Vname)
      },
      handleSizeChange(val) {
        this.pageSize = val
        this.updata(this.pageIndex, this.pageSize,this.form.Vphone, this.form.Vrole, this.form.Vname)
      },
      handleCurrentChange(val) {
        this.pageIndex = val
        this.updata(this.pageIndex, this.pageSize,this.form.Vphone, this.form.Vrole, this.form.Vname)
      },
      edit(index, item) {
        this.$confirm("您确定要重置密码吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(() => {
        let userId = JSON.parse(sessionStorage.getItem("userinfo")).id
        let data = {
          userId,
          id:item.id
        }
        this.$http({
          url: this.$api.userreset,
          method: "PUT",
          data
        }).then(res => {
          if (res.data.code == 200) {
            this.$toast("success", res.data.msg);
            this.updata(this.pageIndex, this.pageSize , this.form.Vphone, this.form.Vrole, this.form.Vname)
          }else{
            this.$toast("error", res.data.msg);
          }
          this.DelVisible = false
        });
      })
        
      },
      btn(){
        this.dialogVisible = true
        this.issubbtn = true
      },
      //删除
      handleDelete(index, item) {
        this.$confirm("您确定要删除这一条记录吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(() => {
        this.$http({
          url: this.$api.userdel + `${item.id}`,
          method: "DELETE",
        }).then(res => {
          if (res.data.code == 200) {
            this.$toast("success", res.data.msg);
            this.updata(1, this.pageSize , this.form.Vphone, this.form.Vrole, this.form.Vname)
          }else{
            this.$toast("error", res.data.msg);
          }
          this.DelVisible = false
        });
      })
        
      },
      onSubmit(formName) {
        console.log(this.subform)
        this.$refs[formName].validate((valid) => {
          if (valid) {
            let userId = JSON.parse(sessionStorage.getItem("userinfo")).id
            if(this.issubbtn){
              let data = {
                userId,
                username:this.subform.username, //账号
                nickname:this.subform.nickname, //用户昵称
                password:this.subform.password, //	密码
                roleId:this.subform.roleId, //角色id
                phone:this.subform.phone, //手机号
              }
              console.log(data)
              this.$http({
                url: this.$api.usersave,
                method: "POST",
                data
              }).then(res => {
                if (res.data.code == 200) {
                  this.$toast("success", res.data.msg);
                  this.updata(1, this.pageSize , this.form.Vphone, this.form.Vrole, this.form.Vname)
                  this.dialogVisible = false
                  this.$refs['form'].resetFields();
                }else{
                  this.$toast("error", res.data.msg);
                }
              })
            } else {
              let data = {
                id:this.listid,
                roleId:this.subform.roleId, //角色id
              }
              this.$http({
                url: this.$api.userupdate,
                method: "PUT",
                data
              }).then(res => {
                if (res.data.code == 200) {
                  this.$toast("success", res.data.msg);
                  this.updata(this.pageIndex, this.pageSize, this.form.Vphone, this.form.Vrole, this.form.Vname)
                  this.dialogVisible = false
                }else{
                  this.$toast("error", res.data.msg);
                }
                this.DelVisible = false
        });
            }
          } else {
            return false;
          }
        });
      },
      handleClose(done) {
        this.dialogVisible = false;
        this.$refs['form'].resetFields();
        this.subform.roleId = ''
      },
      quxiao(){
       this.dialogVisible = false
        this.$refs['form'].resetFields();
        this.subform.roleId = ''
        this.subform.username = ''
        this.subform.nickname = ''
        this.subform.password = ''
        this.subform.phone = ''
      }
    },
    created() { },
    beforeDestroy() { }
  };
</script>

<style lang="scss" scoped>
  .role-select {
    width: 290px !important;
  }

  .content {
    background: #fff;
    width: 100%;
    height: 100%;
  }

  /deep/.el-pagination {
    text-align: center;
    padding: 10px 0;
      position: absolute;
  left: 0;
  right: 0;
  bottom: 0;
  }
  .wrapper{
    height: 100%;

  }
  /deep/.el-table{
      // overflow-x: scroll;
}
/deep/.el-table::before{
  background-color: none;
  opacity:0;
}
/deep/.el-table__body-wrapper{
    height:63vh;
  overflow: auto;
}
/deep/.el-table th>.cell{
  color: #000;
}
</style>